import { cn } from '@/utils/cn'

interface IAdminPageHeader {
    heading?: string
    className?: string
    subheading?: React.ReactNode
    action?: React.ReactNode | null
    secondAction?: React.ReactNode | null
}

export default function AdminPageHeader(props: IAdminPageHeader) {
    const { heading, action, subheading, className, secondAction } = props
    return (
        <div className={cn('bg-brand-50 border-b', className)}>
            <div className='px-4 mx-auto sm:px-6 lg:px-8'>
                <div className='flex items-center justify-between py-8'>
                    <div className='flex-1 min-w-0'>
                        <div className='flex items-center space-x-3'>
                            <div className='w-1 h-8 rounded-full bg-gradient-to-b from-brand-500 to-brand-600'></div>
                            <h1 className='py-2 text-3xl font-bold text-transparent bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text sm:text-4xl'>
                                {heading}
                            </h1>
                        </div>
                        <div className='mt-2 text-sm font-medium text-gray-600'>{subheading}</div>
                    </div>
                    {action && (
                        <div className='flex items-center flex-shrink-0 space-x-3'>
                            {action}
                            <div className='hidden w-px h-8 bg-gray-300 sm:block'></div>
                        </div>
                    )}
                    {secondAction && (
                        <div className='flex items-center flex-shrink-0 space-x-3'>
                            <div className='hidden w-px h-8 bg-gray-300 sm:block'></div>
                            {secondAction}
                            <div className='hidden w-px h-8 bg-gray-300 sm:block'></div>{' '}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
